//
export default [
    {
        text: '#',
        value: 'id',
        sortable: true,
    },
    {
        text: 'origen',
        value: 'sl_sale_document_branch_office',
    },
    {
        text: 'factura',
        value: 'sl_sale_invoice_number',
    },
    {
        text: 'cliente',
        value: 'sl_customer_alias_name',
    },
    {
        text: 'sucursal',
        value: 'sl_customer_branch_offices_address',
    },
    {
        text: 'vendedor',
        value: 'first_pos_sale_user_name_case',
    },
    {
        text: 'tipo',
        value: 'document_type',
        align: 'center',
        component: {
            type: 'chip-label',
            props: {
                palette: {
                    'factura': 'secondary lighten-3',
                    'nota_de_debito': 'accent lighten-3',
                },
                small: true,
            },
        },
    },
    {
        text: 'estado deuda',
        value: 'sl_sale_invoice_status',
        align: 'center',
        component: {
            type: 'chip-label',
            props: {
                palette: {
                    'atrasado': 'error lighten-3',
                    'pagado': 'success lighten-3',
                    'pendiente': 'accent lighten-3',
                    '-': 'grey darken-4 white--text',
                },
                small: true,
            },
        },
    },
    {
        text: 'emisión',
        value: 'emission_date',
        align: 'right',
        format: 'date',
    },
    {
        text: 'vencimiento',
        value: 'pay_date',
        align: 'right',
        format: 'date',
    },
    {
        text: 'pagado',
        value: 'paid_amount',
        align: 'right',
        format: 'currency',
    },
    {
        text: 'monto',
        value: 'amount',
        align: 'right',
        format: 'currency',
    },
    {
        text: 'saldo',
        value: 'balance',
        align: 'right',
        format: 'currency',
        classes: 'grey lighten-3',
    },
    /*{
        text: 'creación',
        value: 'created_at',
        align: 'right',
        format: 'datetime',
    },*/
]
